import { useState } from 'react'

import { useAuthedImage } from '../hooks/useAuthedImage'

export default function PageViewer({ src, filename }: { src: string; filename: string }) {
  const [zoom, setZoom] = useState(1)
  const { objectUrl, error } = useAuthedImage(src)

  return (
    <div className="viewer">
      <div className="viewer-toolbar">
        <span
          className="mono"
          style={{
            fontSize: 11, color: 'var(--text-3)', overflow: 'hidden',
            textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0,
          }}
          title={filename}
        >
          {filename}
        </span>
        <div className="grow" />
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => setZoom((z) => Math.max(0.5, +(z - 0.25).toFixed(2)))}
          aria-label="Zoom out"
        >−</button>
        <span className="mono" style={{ fontSize: 11, minWidth: 38, textAlign: 'center' }}>
          {Math.round(zoom * 100)}%
        </span>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => setZoom((z) => Math.min(4, +(z + 0.25).toFixed(2)))}
          aria-label="Zoom in"
        >+</button>
        <button className="btn btn-ghost btn-sm" onClick={() => setZoom(1)}>Fit</button>
        {objectUrl && (
          <a className="btn btn-ghost btn-sm" href={objectUrl} target="_blank" rel="noreferrer">
            Open
          </a>
        )}
      </div>

      <div className="viewer-scroll">
        {error ? (
          <div className="empty" style={{ padding: '40px 20px' }}>
            <div className="empty-title">Preview unavailable</div>
            <div style={{ fontSize: 12.5 }}>{error}</div>
          </div>
        ) : !objectUrl ? (
          <div className="skeleton" style={{ height: 460 }} />
        ) : (
          <img
            src={objectUrl}
            alt="Uploaded invoice"
            style={{ width: `${zoom * 100}%` }}
          />
        )}
      </div>
    </div>
  )
}
